<template>
  <v-app>
    <v-main class="pa-4">
      <!-- Filtres -->
      <v-btn-toggle v-model="selectedEtat" mandatory class="mb-4 blue-button">
        <v-btn :value="0">Tous</v-btn>
        <v-btn :value="1">A faire</v-btn>
        <v-btn :value="2">En cours</v-btn>
        <v-btn :value="3">Terminé</v-btn>
      </v-btn-toggle>

      <!-- Grille responsive -->
      <v-row dense>
        <v-col
          v-for="(item, index) in filteredItems"
          :key="index"
          cols="6"
          md="4"
          lg="3"
        >
          <v-hover v-slot="{ isHovering, props }">
            <v-card
              v-bind="props"
              class="blue-card ma-2 pa-4 transition-fast-in-fast-out "
              :elevation="isHovering ? 10 : 0"
              @click="goToProjet(item.id)"
              style="cursor: pointer"
              variant="outlined"
              height="90px"
            >
              <!-- Pastille d'état -->
              <div
                :class="['etat-dot', getEtatColorClass(item.etat)]"
                style="position: absolute; top: 8px; right: 8px; width: 12px; height: 12px; border-radius: 50%;"
              ></div>

              <div class="d-flex align-center mb-0">
                <v-icon size="36" color="primary" class="me-3">{{ item.prependIcon }}</v-icon>
                <div color="warning">
                  <h4 class="text-h8 line-clamp-2">{{ item.title }}</h4>
                  <div v-html="item.subtitle" class="text-caption line-clamp-2"></div>
                </div>
              </div>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-main>
  </v-app>
</template>


<script setup lang="ts">
import { useRouter } from 'vue-router';
import { VueProjetUtilisateur, getMainProjets, GetTypeFromNumber} from '../supabase/client';
import { useUserSession } from '../composables/useUserSession'
import { computed, ref, onMounted } from 'vue';


const projets = ref<VueProjetUtilisateur[]>([])
const selectedEtat = ref<number | null>(null)
const router = useRouter()

const items = computed(() =>
  projets.value.flatMap((projet, index, array) => {

    const icon = GetTypeFromNumber(projet.ProjetType).icon;

    const entry = {
      id: projet.ProjetId,
      title: projet.ProjetNom,
      subtitle: `
        ${formatDate(projet.ProjetDeadline)} <br />
      `,
      prependIcon: icon,
      etat: projet.ProjetEtat
    };

    return [entry];
  })
);

// Filtrage dynamique
const filteredItems = computed(() =>
  selectedEtat.value === 0
    ? items.value
    : items.value.filter(item => item.etat === selectedEtat.value)
)

// Format date FR
const formatDate = (dateStr: string | Date) =>
  new Date(dateStr).toLocaleDateString('fr-FR')


// Couleur de pastille selon état
const getEtatColorClass = (etat: number) => {
  switch (etat) {
    case 1: return 'bg-error'
    case 2: return 'bg-warning'
    case 3: return 'bg-success'
    default: return 'bg-grey'
  }
}

// Redirection vers le détail
const goToProjet = (id: number) => {
  router.push({ name: 'DetailProjet', params: { id } })
}

const LoadMainProjets = async () => {
  console.log(" -- Début LoadMainProjets --");

  try {
    console.log("Début useUserSession");
    const { user } = useUserSession();
    console.log("Début useUserSession");

    if (!user.value) {
      throw new Error('Utilisateur non authentifié');
    }

    console.log("Début getMainProjets");
    const result = await getMainProjets(user.value.id);
    console.log("Fin getMainProjets");

    console.log('result = ', result);
    projets.value = result;
  }catch(e){
    console.error('Erreur dans LoadMainProjets', e); 
  }

  console.log(" -- Fin LoadMainProjets --");
}

onMounted(async () => {
  try
  {
    selectedEtat.value=0
    console.log("-- Début OnMounted --");
    console.log("Début useUserSession");
    const { user } = useUserSession();
    console.log("Fin useUserSession");

    if (!user.value) {
      throw new Error('Utilisateur non authentifié');
    }

    console.log("Début LoadMainProjets");
    await LoadMainProjets();
    console.log("Fin LoadMainProjets");

    console.log("-- Fin OnMounted --");

  }catch(e){
    console.error(e);
  }
});
</script>